import React from 'react'
import Enterprises from '../../../../components/customer/enterprises/Enterprises'

const AEACustomerEnterprises = () => {
    return <Enterprises />
}

export default AEACustomerEnterprises
